import React from "react";

import "./ai-about.css";
// import AiBotGif from "./ai bot gif.gif";

const AiAbout = () => {
  const sectionScrollHandler = (sectionId) => {
    const section = document.getElementById(sectionId);

    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <section id="ai_about_section">
        {/* <div id="ai_about_img">
          <img src={AiBotGif} alt="" />
        </div> */}
        <div id="ai_about_txt_div">
          <h3 id="ai_about_hdng">About AI Assistant</h3>
          <p id="ai_about_txt">
            we bring you an AI Assistant Tool designed to transform the way you
            do business. By automating repetitive tasks, delivering error-free
            communication, and offering real-time client engagement, our AI
            Assistant saves time, enhances efficiency, and helps you close more
            deals.
            <br />
            Whether it’s managing queries, making voice calls, or simplifying
            complex ERP workflows, our AI Assistant works 24/7 to ensure no lead
            is ever missed.
          </p>
          <button
            id="ai_package_btn"
            onClick={() => {
              sectionScrollHandler("ai_packages_section");
            }}
          >
            View Packages
          </button>
        </div>
      </section>
    </>
  );
};

export default AiAbout;
